import { useUserSync } from '@/hooks/useUserSync';
import { type ReactNode, createContext, useContext } from 'react';

type UserSyncState = ReturnType<typeof useUserSync>;

const UserSyncContext = createContext<UserSyncState | null>(null);

export function UserSyncProvider({ children }: { children: ReactNode }) {
  const userSync = useUserSync();

  return <UserSyncContext.Provider value={userSync}>{children}</UserSyncContext.Provider>;
}

export function useUserSyncContext(): UserSyncState {
  const context = useContext(UserSyncContext);

  if (!context) {
    throw new Error('useUserSyncContext must be used within UserSyncProvider');
  }

  return context;
}
